import React from 'react';
import { Box, Typography, Card, CardContent, CardActionArea, Chip } from '@mui/material';
import { GeneratedPostVariant } from '../../types/api';

interface PostVariantPickerProps {
  variants: GeneratedPostVariant[];
  selectedIndex: number;
  onSelect: (index: number) => void;
}

export const PostVariantPicker: React.FC<PostVariantPickerProps> = ({
  variants,
  selectedIndex,
  onSelect,
}) => {
  if (variants.length === 0) return null;

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle2" gutterBottom>
        Pick a tone variant
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        {variants.map((variant, index) => (
          <Card
            key={variant.style}
            variant="outlined"
            sx={{
              flex: '1 1 200px',
              maxWidth: 320,
              borderWidth: selectedIndex === index ? 2 : 1,
              borderColor: selectedIndex === index ? 'primary.main' : 'divider',
            }}
          >
            <CardActionArea onClick={() => onSelect(index)}>
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography variant="subtitle1" fontWeight={600}>
                    {variant.label}
                  </Typography>
                  {selectedIndex === index && (
                    <Chip label="Selected" size="small" color="primary" />
                  )}
                </Box>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    display: '-webkit-box',
                    WebkitLineClamp: 4,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  {variant.content}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default PostVariantPicker;
